import { IProduct } from 'src/@interfaces'
import { Api } from './api'
import { getSlugOrState } from 'src/helpers/getSlugOrState/getSlugOrState'
import { BestSellersParams } from './service.types'
import { getConfig } from 'src/helpers'

export async function getBestSellers(params: BestSellersParams) {
  const { pagination, isGenericReseller } = params
  const visitorId = localStorage.getItem('userid')

  return await Api.get<{ products: IProduct[] }>(`/product/recommendation/`, {
    params: {
      pageSize: pagination.page_size,
      visitorId,
      ...getSlugOrState({ reseller: params.reseller, isGenericReseller }),
      businessUnit: getConfig().businessUnit,
    },
  })
}
